import React, { PropsWithChildren, useEffect, useState } from 'react';
import { useTransition } from 'react-spring';
import { ViewProps } from 'react-native';

import { CHAT_ITEM_ANIMATION_CONFIG } from 'modules/chat/components/main/constants';

import { AnimatedContainer } from './styles';

/**
 * Wraps children in a container which uses the animation used in the chat
 *
 * @param props - props used by the FakeChatAnimated component
 */
export function FakeChatAnimated(props: FakeChatAnimatedProps) {
  const [show, setShow] = useState(false);
  const transitions = useTransition(show, null, CHAT_ITEM_ANIMATION_CONFIG);

  useEffect(() => {
    setShow(true);
  }, [setShow]);

  return (
    <>
      {transitions.map(
        ({ item, key, props: transitionProps }) =>
          item && (
            <AnimatedContainer key={key} style={transitionProps}>
              {props.children}
            </AnimatedContainer>
          )
      )}
    </>
  );
}
// Props used by the FakeChatAnimated component
type FakeChatAnimatedProps = PropsWithChildren<ViewProps>;
